import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { doc, onSnapshot, collection, query, where } from "firebase/firestore";
import { PDFDownloadLink, Document, Page, View, Text, StyleSheet, Image } from "@react-pdf/renderer";
import { Link } from "react-router-dom";

export default function TicketPanel() {
  const [userAcc, setUserAcc] = useState(null);
  const [pendingOrders, setPendingOrders] = useState([]);
  const [acceptedOrders, setAcceptedOrders] = useState([]);

    const [error, setError] = useState("");

  // 1️⃣ Pobranie konta użytkownika
  useEffect(() => {
    if (!auth?.currentUser) return;
    const uid = auth.currentUser.uid;
    const userRef = doc(db, "users", uid);
    const unsubUser = onSnapshot(userRef, snap => {
      if (snap.exists()) setUserAcc(snap.data());
      else {
        const galaRef = doc(db, "galaUsers", uid);
        const unsubGala = onSnapshot(galaRef, galaSnap => {
          if (galaSnap.exists()) setUserAcc(galaSnap.data());
        });
        return () => unsubGala();
      }
    });
    return () => unsubUser();
  }, [auth?.currentUser]);

  // 2️⃣ Pobranie zamówień pending i accepted dla bieżącego użytkownika
  useEffect(() => {
    if (!auth?.currentUser) return;
    const uid = auth.currentUser.uid;
    const qPending = query(collection(db, "purchases"), where("customer", "==", uid), where("status", "==", "pending"));
    const qAccepted = query(collection(db, "purchases"), where("customer", "==", uid), where("status", "==", "accepted"));
    const unsubPending = onSnapshot(qPending, snap => setPendingOrders(snap.docs.map(d => ({ id: d.id, ...d.data() }))));
    const unsubAccepted = onSnapshot(qAccepted, snap => setAcceptedOrders(snap.docs.map(d => ({ id: d.id, ...d.data() }))));
    return () => { unsubPending(); unsubAccepted(); };
  }, [auth?.currentUser]);

  const waitingTickets = pendingOrders.flatMap(o =>
    o.seats.map(s => ({
      ticketId: `${o.id}_${s.id}`,
      orderId: o.id,
      date: o.createdAt,
      row: s.row,
      num: s.num,
      price: s.finalPrice,
      isDiscount: s.isDiscount,
      tour: s?.tour
    }))
  );

  const tickets = acceptedOrders.flatMap(o =>
    o.seats.map(s => ({
      ticketId: `${o.id}_${s.id}`,
      orderId: o.id,
      date: o.createdAt,
      row: s.row,
      num: s.num,
      price: s.finalPrice,
      isDiscount: s.isDiscount,
      tour: s?.tour
    }))
  );

  const ticketStyles = StyleSheet.create({
        body: {
            paddingTop: 25,
            paddingBottom: 65,
            paddingHorizontal: 35,
            width: "50%"
        },
        imageBack: {
            position: "absolute",
            left: "0px",
            right: "0px",
            width: "100vw",
            height: "100vh",
            marginHorizontal: 'auto'
        },
    });

  const TicketDocumentSeat = ({ ticket }) => (
    <Document>
      <Page size="A4" style={ticketStyles.body}>
        <Image
            style={ticketStyles.imageBack}
            src={process.env.PUBLIC_URL + "/ticket.png"}
            fixed
        />
        <Text style={{top: "150px", left: "33px", fontSize: "11px", fontWeight: "bold"}}>{ticket?.tour}{ticket.row?.toUpperCase()}{ticket.num}</Text>
        <Text style={{top: "142px", left: "118px", fontSize: "7px", fontWeight: "bold"}}>Bilet {ticket.isDiscount ? "ulgowy" : "normalny"}</Text>
        <Text style={{top: "135px", left: "241px", fontSize: "7px", fontWeight: "bold"}}>Tura {ticket.tour}</Text>
        <Text style={{top: "127px", left: "351px", fontSize: "7px", fontWeight: "bold"}}>{ticket.row?.toUpperCase()}</Text>
        <Text style={{top: "118.5px", left: "458px", fontSize: "7px", fontWeight: "bold"}}>{ticket.num}</Text>
      </Page>
    </Document>
  );

  return (
    <div style={({display:"flex",justifyContent:"flex-start",alignItems:"center",flexDirection:"column",backgroundColor:"rgb(240,240,240)",width:"100%",minHeight:"100vh",gap:"30px", position: "relative", overflow: "hidden"})}>
        <div style={({display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center",position:"fixed",zIndex:"40",top:error?"45px":"-300px",transform:"translate(-50%, -50%)",left:"50%",backgroundColor:"rgb(250,250,250)",width:"320px",height:"75px",transition:"0.8s",borderRadius:"15px",border:"3px solid rgb(215,0,64)",gap:"20px"})}>
            <img src={process.env.PUBLIC_URL + "/error.png"} style={({width:"30px"})}/>
            <h3 style={({fontSize:"13px",fontWeight:"bold",color:"rgb(215,0,64)",textAlign:"center",width:"75%"})}>{error}</h3>
        </div>
        <nav style={({width: "100%", borderBottom: "1px solid rgb(30,30,30)", height: "60px", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"})}>
            <div style={({display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "90%", marginLeft: "-10px"})}>
                <img src={process.env.PUBLIC_URL + "logo4STARS.png"} style={({width: "45px"})} />
                <Link to={"/wybor-panelu"}><img src={process.env.PUBLIC_URL + "logout_black.png"} style={({width: "22px"})}/></Link>
            </div>
        </nav>
      <h2 style={{fontSize:"20px",fontWeight:"bold"}}>Oczekujące zamówienia</h2>
      <div style={{width:"100%",maxWidth:"1200px",display:"flex",flexDirection:"row",gap:"15px", justifyContent: "center", alignItems: "center", flexWrap: "wrap"}}>
        {waitingTickets.length ? waitingTickets.map(t =>
            <div style={({display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "130px", height: "130px", padding: "20px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1.5px, rgb(209, 213, 219) 0px 0px 0px 1px", margin: "3px", borderRadius: "3px", backgroundColor: "rgb(255,255,255,0.75)"})}>
                <img src="invit_blue.png" style={({width: "37.5px", marginBottom: "10px"})} />
                <div style={({display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "2px", marginBottom: "10px"})}>
                    <h3 style={({color: "rgb(35,35,35)", fontSize: "11px", fontWeight: "bold", letterSpacing: "0.1px", textAlign: "center"})}>{t?.isDiscount ? "Bilet ulgowy 50 zł" : "Bilet normalny " + t?.price + " zł"}</h3>
                    <h3 style={({color: "#fcba03", fontSize: "11px", fontWeight: "bold", letterSpacing: "0.1px", textAlign: "center"})}>Status: Oczekujący</h3>
                </div>
                <div style={({display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start", gap: "2px", width: "100%"})}>
                    <h3 style={({color: "rgb(35,35,35)", fontSize: "11px", fontWeight: "bold", letterSpacing: "0.1px"})}>Rząd: {t?.row?.toUpperCase()}</h3>
                    <h3 style={({color: "rgb(35,35,35)", fontSize: "11px", fontWeight: "bold", letterSpacing: "0.1px"})}>Miejsce: {t?.num}</h3>
                </div>
            </div>
        ) : <p style={{color:"#666"}}>Brak oczekujących biletów</p>}
      </div>

      <h2 style={{fontSize:"20px",fontWeight:"bold"}}>Twoje bilety</h2>
      <div style={{width:"100%",maxWidth:"1200px",display:"flex",flexDirection:"row",gap:"15px", justifyContent: "center", alignItems: "center", flexWrap: "wrap"}}>
        {tickets.length ? tickets.map(t =>
            <div style={({display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "130px", height: "130px", padding: "20px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1.5px, rgb(209, 213, 219) 0px 0px 0px 1px", margin: "3px", borderRadius: "3px", backgroundColor: "rgb(255,255,255,0.75)"})}>
                <img src="invit_blue.png" style={({width: "37.5px", marginBottom: "10px"})} />
                <div style={({display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "2px", marginBottom: "10px"})}>
                    <h3 style={({color: "rgb(35,35,35)", fontSize: "11px", fontWeight: "bold", letterSpacing: "0.1px", textAlign: "center"})}>{t?.isDiscount ? "Bilet ulgowy 50 zł" : "Bilet normalny " + t?.price + " zł"}</h3>
                    <h3 style={({color: "green", fontSize: "11px", fontWeight: "bold", letterSpacing: "0.1px", textAlign: "center"})}>Status: Opłacony</h3>
                </div>
                <div style={({display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start", gap: "2px", width: "100%"})}>
                    <h3 style={({color: "rgb(35,35,35)", fontSize: "11px", fontWeight: "bold", letterSpacing: "0.1px"})}>Rząd: {t?.row?.toUpperCase()}</h3>
                    <h3 style={({color: "rgb(35,35,35)", fontSize: "11px", fontWeight: "bold", letterSpacing: "0.1px"})}>Miejsce: {t?.num}</h3>
                </div>
                <PDFDownloadLink
                    document={<TicketDocumentSeat ticket={t}/>}
                    fileName={`bilet-${t?.row}-${t?.num}.pdf`}
                    style={{textDecoration:"none"}}
                >
                    <button style={{background:"#0045C7",border:"none",color:"#fff",padding:"4px 8px",borderRadius:"3px",cursor:"pointer", marginTop: "10px", fontSize: "11px", fontWeight: "bold"}}>Pobierz bilet</button>
                </PDFDownloadLink>
            </div>
        ) : <p style={{color:"#666"}}>Brak zakupionych biletów</p>}
        </div>
    </div>
  );
}
